import { Box, Typography } from '@mui/material'
import FeedbackBtn from '../utils/FeedbackBtn'

function Feedback() {
  return (
    <Box sx={{
      width: '100%',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      flexDirection: 'column'
    }} mt={12}>
      <Typography variant="h6" gutterBottom component="div">
        <FeedbackBtn variant='outlined' sx={{ width: '100%', mb: 1, textTransform: 'none' }} />
      </Typography>
    </Box>
  )
}

export default Feedback